interface ArticleDisclaimerProps {
  text: string;
  /** Optional — when true the section uses the tinted bg to match the
   *  alternating section above it. */
  tinted?: boolean;
}

/**
 * Trademark / legal disclaimer rendered at the foot of an article page.
 *
 * Figma (Section 5 inner row, large 1440px):
 *   - Sits inside the same final section as the last article row, separated
 *     by a `gap-[120px]` (handled by the parent ArticlePage)
 *   - Disclaimer block: `flex flex-col gap-[24px]`
 *     - 0.7px hairline #D8D5D2 across full width
 *     - Paragraph: Karla Regular 12/14, color #62605E, full width
 */
export function ArticleDisclaimer({ text, tinted = false }: ArticleDisclaimerProps) {
  return (
    <section
      className={`px-6 pb-30 md:px-14 lg:px-20 lg:pb-50 xl:px-30 ${
        tinted ? 'bg-clearlab-divider-light/20' : 'bg-clearlab-oat'
      }`}
    >
      <div className="mx-auto flex w-full max-w-content-xl flex-col items-start gap-6">
        <hr className="w-full border-0 border-t-[0.7px] border-clearlab-divider-darker" />
        <p className="w-full text-[12px] font-normal leading-[14px] text-clearlab-steel">{text}</p>
      </div>
    </section>
  );
}
